// extracted by mini-css-extract-plugin
export default {"checkbox-input":"styles-module_checkbox-input---dOcLI","checkbox-input--bordered":"styles-module_checkbox-input--bordered---k40PN"};